module.exports = __webpack_public_path__ + "static/media/bg_bike.f0a0a210.png";